import Vue from 'vue';
import { EventBus } from '@/event-bus';

export default Vue.extend({
  data() {
    return {
      refreshError: false,
    };
  },
  methods: {
    triggerRefreshError(config = {}): void {
      this.refreshError = true;
      const DEFAULT_CONFIG = {
        message: 'global_connection-error',
        action: {
          label: 'global_refresh',
          performAction() {
            location.reload();
          },
        },
        hideCancel: true,
      };
      Object.assign(DEFAULT_CONFIG, config);
      EventBus.$emit('openModal', 'Error', DEFAULT_CONFIG);
    },
  },
});
